export function currentLanguage() {
  if (typeof window === "undefined") return "en";
  const path = window.location?.pathname || "";
  const htmlLang = document.documentElement?.lang || "";

  if (path === "/es" || path.startsWith("/es/")) return "es";
  if (htmlLang.toLowerCase().startsWith("es")) return "es";
  return "en";
}

export function apiUrlWithLang(url) {
  const lang = currentLanguage();
  const joiner = url.includes("?") ? "&" : "?";
  return `${url}${joiner}lang=${encodeURIComponent(lang)}`;
}

export function withLanguage(payload = {}) {
  return { ...payload, lang: currentLanguage() };
}
